<template>
    <psi-dialog
        :icon="$config('icons.student')"
        :title="title"
        @close="$emit('close')"
        hide-actions
    >
        <v-row justify="center">
            <v-col lg="9" sm="12" md="12">
                <div class="d-flex align-center mx-auto justify-center">
                    <v-avatar size="130">
                        <img :src="program.icon_filepath" />
                    </v-avatar>
                    <h2>{{ program.name }}</h2>
                </div>
                <v-toolbar color="secondary" dark>
                    <v-toolbar-title
                        >Students <v-chip>{{ count }}</v-chip></v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                    <div style="width: 300px">
                        <v-text-field
                            clearable
                            prepend-inner-icon="mdi-magnify"
                            class="mt-4"
                            placeholder="Search student, instructor"
                            v-model="search"
                        >
                        </v-text-field>
                    </div>
                </v-toolbar>
                <v-data-table
                    :items="programStudents"
                    disable-pagination
                    show-select
                    v-model="selectedStudents"
                    :search="search"
                    :headers="headers"
                    hide-default-footer
                    :loading="dataLoading"
                    :custom-filter="filterStudents"
                >
                    <template
                        v-slot:item.data-table-select="{
                            item,
                            isSelected,
                            select,
                        }"
                    >
                        <v-simple-checkbox
                            v-if="!$_.get(item, 'meta.graduated', false)"
                            :value="isSelected"
                            @input="select($event)"
                        ></v-simple-checkbox>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-btn
                            small
                            v-if="$_.get(item, 'meta.graduated', false)"
                            color="primary"
                            @click="resend(item.id)"
                        >
                            <v-icon small class="mr-2">mdi-email-send</v-icon>
                            Resend Invite
                        </v-btn>
                    </template>
                    <template v-slot:item.graduate="{ item }">
                        <v-avatar class="my-2">
                            <v-icon
                                large
                                class="primary--text"
                                v-if="$_.get(item, 'meta.graduated', false)"
                                >mdi-school</v-icon
                            >
                            <v-icon
                                v-if="!$_.get(item, 'meta.graduated', false)"
                            >
                                mdi-progress-clock
                            </v-icon>
                        </v-avatar>
                    </template>
                    <template v-slot:item.photo="{ item }">
                        <v-avatar class="my-2">
                            <v-img :src="item.profile_photo_url"></v-img>
                        </v-avatar>
                    </template>
                    <template v-slot:item.instructorPhoto="{ item }">
                        <v-avatar class="my-2">
                            <v-img
                                :src="item.instructor.profile_photo_url"
                            ></v-img>
                        </v-avatar>
                    </template>
                    <template v-slot:item.completed_at="{ item }">
                        <span>{{ completedAt(item) }}</span>
                    </template>
                    <template v-slot:item.status="{ item }">
                        <v-chip
                            small
                            class="text-uppercase"
                            :color="itemStatusLabel(item)['color']"
                            >{{ itemStatusLabel(item)["label"] }}</v-chip
                        >
                    </template>
                </v-data-table>
                <v-toolbar color="grey lighten-2" flat dense>
                    <v-spacer></v-spacer>
                    <v-btn class="mr-4" @click.stop="$emit('close')"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="accent"
                        class="px-4"
                        :disabled="!selected"
                        @click.stop="graduate"
                        :loading="dataLoading"
                    >
                        <v-icon class="mr-1">{{
                            $config("icons.student")
                        }}</v-icon>
                        Graduate Students
                    </v-btn>
                </v-toolbar>
            </v-col>
        </v-row>
    </psi-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
    name: "student-graduate",
    props: {
        program: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            search: "",
            selectedStudents: [],
            headers: [
                {
                    text: "Graduate",
                    align: "start",
                    sortable: true,
                    value: "graduate",
                    cellClass: "mt-2",
                    class: "text-subtitle-2 font-weight-medium accent--text text-uppercase",
                },

                {
                    text: "",
                    align: "start",
                    sortable: true,
                    value: "photo",
                    cellClass: "mt-2",
                    class: "text-subtitle-2 font-weight-medium accent--text text-uppercase",
                },
                {
                    text: "Student Name",
                    align: "start",
                    sortable: true,
                    value: "name",
                    class: "text-subtitle-2 font-weight-medium accent--text text-uppercase",
                },
                {
                    text: "Status",
                    align: "center",
                    sortable: true,
                    value: "status",
                    class: "text-subtitle-2 font-weight-medium accent--text text-uppercase",
                },
                {
                    text: "Completed Date",
                    align: "center",
                    sortable: true,
                    value: "completed_at",
                    class: "text-subtitle-2 font-weight-medium accent--text text-uppercase",
                },

                {
                    text: "",
                    align: "start",
                    sortable: true,
                    value: "instructorPhoto",
                    class: "text-subtitle-2 font-weight-medium accent--text text-uppercase",
                },
                {
                    text: "Instructor Name",
                    align: "start",
                    sortable: true,
                    value: "instructor.name",
                    class: "text-subtitle-2 font-weight-medium accent--text text-uppercase",
                },
                {
                    text: "Actions",
                    align: "center",
                    sortable: false,
                    value: "actions",
                    class: "text-subtitle-2 font-weight-medium accent--text text-uppercase",
                },
            ],
        };
    },
    computed: {
        ...mapGetters("Programs", ["programStudents", "dataLoading"]),
        title() {
            return "Graduate Students";
        },
        count() {
            return this.programStudents.length;
        },
        selected() {
            return this.selectedStudents.length > 0;
        },
    },
    methods: {
        ...mapActions("Programs", [
            "getProgramStudents",
            "graduateStudents",
            "resendInvite",
        ]),
        ...mapMutations("Programs", ["SET_PROGRAM_STUDENTS"]),
        resend(id) {
            this.resendInvite({
                programId: this.program.id,
                graduated: true,
                students: [{ id }],
            });
        },
        graduate() {
            this.graduateStudents({
                programId: this.program.id,
                graduated: true,
                students: this.selectedStudents.map((item) => {
                    return {
                        id: item.id,
                    };
                }),
            });
            this.selectedStudents = [];
        },
        filterStudents(value, search, item) {
            return (
                value != null &&
                search != null &&
                typeof value === "string" &&
                (item.instructor.name
                    .toLowerCase()
                    .includes(search.toLowerCase()) ||
                    item.name.toLowerCase().includes(search.toLowerCase()))
            );
        },
        completedAt(item) {
            const date = this.$_.get(item, "order.completed_at", "");
            return date ? date.split(" ").shift() : "--";
        },
        itemStatusLabel(item) {
            const status = this.$_.get(item, "order.status", "");
            return status
                ? this.statusLabel(item.order.status)
                : { color: "warning", label: "N/A" };
        },
        statusLabel(status) {
            switch (status) {
                case "SCREEN_COMPLETED":
                    return {
                        color: "primary",
                        label: "Report Completed",
                    };
                case "APPLICANT_SUBMITTED":
                    return {
                        color: "warning darken-2",
                        label: "Report Pending",
                    };

                default:
                    return {
                        color: "warning darken-2",
                        label: "Report Pending",
                    };
            }
        },
    },
    mounted() {
        this.SET_PROGRAM_STUDENTS([]);
        this.getProgramStudents(this.program.id);
    },
};
</script>

<style lang="scss" scoped>
</style>